import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { Environment } from 'src/app/models/api';
import { EnvironmentSelectByOptions } from 'src/app/models/selectOptions';
import { ISelectionButton } from '../../selection-button/selection-button.component';
import { RequiredFieldTitlePipe } from 'src/app/pipes/required-field-title/required-field-title.pipe';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';

@Component({
  selector: 'app-integration-environment',
  templateUrl: './integration-environment.component.html',
  styleUrls: ['./integration-environment.component.scss'],
})
export class IntegrationEnvironmentComponent implements OnInit {
  @Input() public inAddMode: boolean;
  @Input() public environmentFormControl: FormControl<string>;

  private readonly _requiredFieldPipe = inject(RequiredFieldTitlePipe);
  private readonly _labelsProviderPipe = inject(LabelsProviderPipe);

  public environmentSelectionButtons: BehaviorSubject<BehaviorSubject<ISelectionButton>[]> = new BehaviorSubject<
    BehaviorSubject<ISelectionButton>[]
  >([]);

  public getEnvironmentTitle(): string {
    return this.inAddMode
      ? this._requiredFieldPipe.transform('integrationPage.addModeEnvironmentField')
      : this._labelsProviderPipe.transform('integrationPage.editModeEnvironmentField');
  }

  ngOnInit(): void {
    const environmentSelectionButtons: BehaviorSubject<ISelectionButton>[] = [];
    const selectedIndex = EnvironmentSelectByOptions.map((env) => env.id).indexOf(this.environmentFormControl.value);

    EnvironmentSelectByOptions.forEach((environment, index) => {
      const isSelected = selectedIndex === index;
      if (this.inAddMode || isSelected) {
        environmentSelectionButtons.push(
          new BehaviorSubject<ISelectionButton>({
            id: environment.id,
            text: environment.displayName,
            selected: isSelected ? true : false,
          })
        );
      }
    });
    this.environmentSelectionButtons.next(environmentSelectionButtons);
  }

  public onEnvironmentSelected(selectedButton: ISelectionButton) {
    this.environmentFormControl.setValue(<Environment>selectedButton.id);
  }
}
